export class DashboardGrid {
    gridskin() {
        return `
            <div class="container-layout d-grid grid-2">
                <div class="container-column grow-col-2">
                    <div class="column-header">
                        <div class="header-title has-icon">
                            <span class="iconify" data-icon="mingcute:control-line"></span>
                            <h3>Mini Control Panel</h3>
                            <div class="header-actions">
                                <button class="full-screen-button" title="Full Screen">
                                    <span class="iconify" data-icon="akar-icons:enlarge" data-inline="false"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="container-body">
                        <div class="table-responsive">
                            <table class="has-min-width">
                                <thead>
                                    <tr>
                                        <th>Control</th>
                                        <th class="text-right">Unit</th>
                                        <th class="text-right">Value</th>
                                        <th class="text-right">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Active Power Limit</td>
                                        <td class="text-right">%</td>
                                        <td class="text-right bg-subcontainer" data-register="Active_Power_Limit">0</td>
                                        <td class="text-right"><button class="register-edit" data-register="Active_Power_Limit"><span class="iconify" data-icon="ic:baseline-edit"></span></button></td>
                                    </tr>
                                    <tr>
                                        <td>Active Power Setpoint</td>
                                        <td class="text-right">kW</td>
                                        <td class="text-right bg-subcontainer" data-register="Active_Power_Setpoint">0</td>
                                        <td class="text-right"><button class="register-edit" data-register="Active_Power_Setpoint"><span class="iconify" data-icon="ic:baseline-edit"></span></button></td>
                                    </tr>
                                    <tr>
                                        <td>PPC Active Power Mode</td>
                                        <td class="text-right"></td>
                                        <td class="text-right bg-subcontainer" data-register="PPC_Active_Power_Mode">0</td>
                                        <td class="text-right"><button class="register-edit" data-register="PPC_Active_Power_Mode"><span class="iconify" data-icon="ic:baseline-edit"></span></button></td>
                                    </tr>
                                    <tr>
                                        <td>Power Factor Setpoint</td>
                                        <td class="text-right"></td>
                                        <td class="text-right bg-subcontainer" data-register="Power_Factor_Setpoint">0</td>
                                        <td class="text-right"><button class="register-edit" data-register="Power_Factor_Setpoint"><span class="iconify" data-icon="ic:baseline-edit"></span></button></td>
                                    </tr>
                                    <tr>
                                        <td>Plant Enable Command (Emergency Stop)</td>
                                        <td class="text-right"></td>
                                        <td class="text-right bg-subcontainer" data-register="Plant_Enable_Command">0</td>
                                        <td class="text-right"><button class="register-edit" data-register="Plant_Enable_Command"><span class="iconify" data-icon="ic:baseline-edit"></span></button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="container-column">
                    <div class="column-header">
                        <div class="header-title has-icon">
                            <span class="iconify" data-icon="mingcute:performance-line"></span>
                            <h3>Array Summary</h3>
                            <div class="header-actions">
                                <button class="full-screen-button" title="Full Screen">
                                    <span class="iconify" data-icon="akar-icons:enlarge" data-inline="false"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="container-body">
                        <div class="table-responsive">
                            <table class="has-min-width">
                                <thead>
                                    <tr>
                                        <th colspan="2"></th>
                                        <th>BLOCK 1</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="has-icon">Control Mode <span class="iconify" data-icon="ic:baseline-edit"></span></td>
                                        <td class="text-right"></td>
                                        <td class="text-right bg-subcontainer">0</td>
                                    </tr>
                                    <tr>
                                        <td class="has-icon">Manual Q SP <span class="iconify" data-icon="ic:baseline-edit"></span></td>
                                        <td class="text-right">%</td>
                                        <td class="text-right bg-subcontainer">0</td>
                                    </tr>
                                    <tr>
                                        <td class="has-icon">Manual P SP <span class="iconify" data-icon="ic:baseline-edit"></span></td>
                                        <td class="text-right">%</td>
                                        <td class="text-right bg-subcontainer">0</td>
                                    </tr>
                                    <tr>
                                        <td>N Comm. Inv</td>
                                        <td class="text-right"></td>
                                        <td class="text-right bg-subcontainer">0</td>
                                    </tr>
                                    <tr>
                                        <td>N Active Inv</td>
                                        <td class="text-right"></td>
                                        <td class="text-right bg-subcontainer">0</td>
                                    </tr>
                                    <tr>
                                        <td>N Inactive Inv</td>
                                        <td class="text-right"></td>
                                        <td class="text-right bg-subcontainer">0</td>
                                    </tr>
                                    <tr>
                                        <td>N Faulted Inv</td>
                                        <td class="text-right"></td>
                                        <td class="text-right bg-subcontainer">0</td>
                                    </tr>
                                    <tr>
                                        <td>Real Power P</td>
                                        <td class="text-right">kW</td>
                                        <td class="text-right bg-subcontainer">0</td>
                                    </tr>
                                    <tr>
                                        <td>Reactive Power Q</td>
                                        <td class="w-100 text-right">kVAr</td>
                                        <td class="text-right bg-subcontainer">0</td>
                                    </tr>
                                    <tr>
                                        <td>Total Energy</td>
                                        <td class="text-right">kWh</td>
                                        <td class="text-right bg-subcontainer">0</td>
                                    </tr>
                                    <tr>
                                        <td>Daily Energy</td>
                                        <td class="text-right">kWh</td>
                                        <td class="text-right bg-subcontainer">0</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="container-column">
                    <div class="column-header">
                        <div class="header-title has-icon">
                            <h3>Energy Produced Today vs Total Energy</h3>
                            <div class="header-actions d-flex align-center gap-10">
                                <span class="date-display" id="energy_produced_today_vs_total_energy_chart_ display"></span>
                                <input type="hidden" id="energy_produced_today_vs_total_energy_chart_start">
                                <input type="hidden" id="energy_produced_today_vs_total_energy_chart_end">
                                <button class="date-range-button" title="Select Date Range" id="energy_produced_today_vs_total_energy_chart_picker">
                                    <span class="iconify" data-icon="mdi:calendar-range"></span>
                                </button>
                                <button class="full-screen-button" title="Full Screen">
                                    <span class="iconify" data-icon="akar-icons:enlarge"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="container-body d-flex">
                        <div class="column-chart" id="energy_produced_today_vs_total_energy">
                            <div class="chart-type-toggle">
                                <select>
                                    <option value="lines">Line</option>
                                    <option value="markers">Scatter (Markers)</option>
                                    <option value="lines+markers">Line + Markers</option>
                                    <option value="bar">Bar</option>
                                    <option value="area">Area (Filled Line)</option>
                                    <option value="spline">Spline</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-column two-rows grow-row-2">
                    <div class="container-column">
                        <div class="column-header">
                            <div class="header-title has-icon">
                                <span class="iconify" data-icon="mingcute:performance-line"></span>
                                <h3>POI</h3>
                                <div class="header-actions">
                                    <button class="full-screen-button" title="Full Screen">
                                        <span class="iconify" data-icon="akar-icons:enlarge" data-inline="false"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="container-body">
                            <div class="table-responsive">
                                <table class="has-min-width">
                                    <thead>
                                        <tr>
                                            <th colspan="2"></th>
                                            <th>MTRO1</th>
                                            <th>MTRO2</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Active Power</td>
                                            <td class="w-100 text-right">kW</td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                        </tr>
                                        <tr>
                                            <td>Frequency</td>
                                            <td class="w-100 text-right">Hz</td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                        </tr>
                                        <tr>
                                            <td>Voltage</td>
                                            <td class="w-100 text-right">kV</td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                        </tr>
                                        <tr>
                                            <td>Power Factor</td>
                                            <td class="w-100 text-right"></td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                        </tr>
                                        <tr>
                                            <td>Reactive Power</td>
                                            <td class="w-100 text-right">kVAr</td>
                                            <td class="text-right w-100 bg-subcontainer">50</td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="container-column">
                        <div class="column-header">
                            <div class="header-title has-icon">
                                <span class="iconify" data-icon="mingcute:performance-line"></span>
                                <h3>Reactive Control</h3>
                                <div class="header-actions">
                                    <button class="full-screen-button" title="Full Screen">
                                        <span class="iconify" data-icon="akar-icons:enlarge" data-inline="false"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="container-body">
                            <div class="table-responsive">
                                <table class="has-min-width">
                                    <tbody>
                                        <tr>
                                            <td>Current Mode</td>
                                            <td class="w-100 text-right"></td>
                                            <td class="text-right w-100 bg-subcontainer">Plant Q Mode</td>
                                        </tr>
                                        <tr>
                                            <td class="has-icon">Mode Q Status<span class="iconify" data-icon="ic:baseline-edit"></span></td>
                                            <td class="w-100 text-right"></td>
                                            <td class="text-right w-100 bg-subcontainer">1</td>
                                        </tr>
                                        <tr>
                                            <td class="has-icon">Mode V Status<span class="iconify" data-icon="ic:baseline-edit"></span></td>
                                            <td class="w-100 text-right"></td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                        </tr>
                                        <tr>
                                            <td class="has-icon">Mode PF Status<span class="iconify" data-icon="ic:baseline-edit"></span></td>
                                            <td class="w-100 text-right"></td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                        </tr>
                                        <tr>
                                            <td class="has-icon">AVR Voltage SP<span class="iconify" data-icon="ic:baseline-edit"></span></td>
                                            <td class="w-100 text-right">PU</td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                        </tr>
                                        <tr>
                                            <td class="has-icon">Power Factor SP<span class="iconify" data-icon="ic:baseline-edit"></span></td>
                                            <td class="w-100 text-right"></td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                        </tr>
                                        <tr>
                                            <td class="has-icon">Manual Plant Q SP<span class="iconify" data-icon="ic:baseline-edit"></span></td>
                                            <td class="w-100 text-right">%</td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="container-column">
                        <div class="column-header">
                            <div class="header-title has-icon">
                                <span class="iconify" data-icon="mingcute:performance-line"></span>
                                <h3>Real Control</h3>
                                <div class="header-actions">
                                    <button class="full-screen-button" title="Full Screen">
                                        <span class="iconify" data-icon="akar-icons:enlarge" data-inline="false"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="container-body">
                            <div class="table-responsive">
                                <table class="has-min-width">
                                    <tbody>
                                        <tr>
                                            <td>Current Mode</td>
                                            <td class="w-100 text-right"></td>
                                            <td class="text-right w-100 bg-subcontainer">Desconocido</td>
                                        </tr>
                                        <tr>
                                            <td class="has-icon">Mode P Status<span class="iconify" data-icon="ic:baseline-edit"></span></td>
                                            <td class="w-100 text-right"></td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                        </tr>
                                        <tr>
                                            <td class="has-icon">Mode Hz Status<span class="iconify" data-icon="ic:baseline-edit"></span></td>
                                            <td class="w-100 text-right"></td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                        </tr>
                                        <tr>
                                            <td class="has-icon">Manual P SP<span class="iconify" data-icon="ic:baseline-edit"></span></td>
                                            <td class="w-100 text-right">%</td>
                                            <td class="text-right w-100 bg-subcontainer">100</td>
                                        </tr>
                                        <tr>
                                            <td class="has-icon">Mode P Ramp Status<span class="iconify" dataicon="ic:baseline-edit"></span></td>
                                            <td class="w-100 text-right">PU</td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                        </tr>
                                        <tr>
                                            <td class="has-icon">Ramp Up SP<span class="iconify" data-icon="ic:baseline-edit"></span></td>
                                            <td class="w-100 text-right">%</td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                        </tr>
                                        <tr>
                                            <td class="has-icon">Ramp Dn SP<span class="iconify" data-icon="ic:baseline-edit"></span></td>
                                            <td class="w-100 text-right">%</td>
                                            <td class="text-right w-100 bg-subcontainer">0</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-column grow-row-3">
                    <div class="column-header">
                        <div class="header-title has-icon">
                            <h3>Voltage & Frequency Trends</h3>
                            <div class="header-actions d-flex align-center gap-10">
                                <span class="date-display" id="voltage_frequency_chart_ display"></span>
                                <input type="hidden" id="voltage_frequency_chart_start">
                                <input type="hidden" id="voltage_frequency_chart_end">
                                <button class="date-range-button" title="Select Date Range" id="voltage_frequency_chart_picker">
                                    <span class="iconify" data-icon="mdi:calendar-range"></span>
                                </button>
                                <button class="full-screen-button" title="Full Screen">
                                    <span class="iconify" data-icon="akar-icons:enlarge"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="container-body d-flex">
                        <div class="column-chart" id="voltage_frequency">
                                <div class="chart-type-toggle">
                                    <select>
                                        <option value="lines">Line</option>
                                        <option value="markers">Scatter (Markers)</option>
                                        <option value="lines+markers">Line + Markers</option>
                                        <option value="bar">Bar</option>
                                        <option value="area">Area (Filled Line)</option>
                                        <option value="spline">Spline</option>
                                    </select>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}